import { AOContainerDirective } from './ao-container.directive';

export interface AOContainerInterface {

  directive: AOContainerDirective;

}
